import Http from "@/utils/request.js";

//用户信息
export function UserInfo(){
	return Http.request({
		url: `/user/userCenter/getUserBaseInfo`,
		method: 'post'
	})
}

//修改用户信息
export function EditUserInfo(data){
	return Http.request({
		url: `/user/userCenter/updateUserInfo`,
		method: 'post',
		data
	})
}

//清理用户缓存
export function CleanCache(){
	return Http.request({
		url: `/user/userCenter/refreshUser`,
		method: 'post'
	})
}

//我的团队
export function TeamList(data){
	return Http.request({
		url: `/user/profit/myTeam`,
		method: 'post',
		data
	})
}

//团队统计
export function TeamStatistics(data){
	return Http.request({
		url: `/user/profit/myTeamTotal`,
		method: 'post',
		data
	})
}

//团队会员等级统计
export function TeamLevelStatistics(level){
	return Http.request({
		url: `/user/profit/getTeamByLevel`,
		method: 'post',
		data:{
			level
		}
	})
}

//修改支付密码
export function ChangePayPassword(data){
	return Http.request({
		url: `/user/userCenter/addOrUpdateTradersPassword`,
		method: 'post',
		data
	})
}

//检查账号 
export function CheckAccount(validCode){
	return Http.request({
		url: `/user/userCenter/checkPhone`,
		method: 'post',
		data:{
			validCode
		}
	})
}

//邀请二维码
export function ShareQrCode(){
	return Http.request({
		url: `/user/userCenter/inviteNewUser`,
		method: 'post',
	})
}

//绑定邀请人
export function BindInvitePerson(invitCode){
	return Http.request({
		url: `/user/userCenter/bindPerson`,
		method: 'post',
		data:{
			invitCode
		}
	})
}

//实名认证
export function Authentication(imgUrl){
	return Http.request({
		url: `/user/auth/userAuthFace`,
		method: 'post',
		data:{
			imgUrl
		}
	})
}

//上传证件照正面
export function UploadIdCardFront(filePath){
	return Http.upload(`/user/auth/userAuthIdCardRx`, {
		name:'file',
		filePath
	})
}

//上传证件照反面
export function UploadIdCardBack(filePath){
	return Http.upload(`/user/auth/userAuthIdCardGh`, {
		name:'file',
		filePath
	})
}

 // 获取认证进度信息
export function AuthInfo(){
 	return Http.request({
 		url: `/user/auth/userAuthInfo`,
 		method: 'post'
 	})
}

 // 获取认证进度信息
export function AuthUploadIdCardInfo(data){
 	return Http.request({
 		url: `/user/auth/checkIdCard`,
 		method: 'post',
		data
 	})
}

//意见反馈
export function sendFeedBack(data){
 	return Http.request({
 		url: `/user/userCenter/feedback`,
 		method: 'post',
		data
 	})
}
